import { Theme } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  dialogContainer: {
    borderRadius: 16,
    boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px 0px rgba(0, 0, 0, 0.06)',
  },
  dialog: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    padding: '31px 0 10px',
  },
  closeBtn: {
    position: 'absolute',
    right: 16,
    top: 16,
    padding: 0,
    height: 16,
    width: 16,
  },
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: 7,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minWidth: 391,
    width: 'auto',
    gap: 10,
    [theme.breakpoints.down('sm')]: {
      minHeight: 'auto',
      minWidth: 'auto',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
  },
  contentAction: {
    minHeight: 40,
    marginBottom: 14,
  },
  submit: {
    width: 98,
  },
  titleIcon: {
    fontSize: 40,
  },
  icon: {
    width: 40,
    height: 60,
  },
  colorPrimary: {
    height: 4,
    background: theme.palette.text.secondary,
    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.06), 0px 1px 3px rgba(0, 0, 0, 0.1)',
    borderRadius: 16,
  },
  barColorPrimary: {
    height: 4,
    background: 'linear-gradient(90deg, #010E29 2.59%, #212121 99.44%)',
  },
  burnDialogTitle: {
    fontSize: 18,
    fontFamily: 'Inter',
    fontWeight: '600',
  },
  burnDialogDesc: {
    fontSize: 14,
    fontFamily: 'Inter',
    textAlign: 'center',
    marginBottom: 24,
    maxWidth: 391,
    color: theme.palette.action.focus,
    whiteSpace: 'pre-line',
  },
}))

import styled from 'styled-components'
import { Typography } from 'primsell-shared-layer/components'

export const Form = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 391px;
  width: auto;
  gap: 10px;

  @media (max-width: 600px) {
    min-height: auto;
    min-width: auto;
  }
`

export const TitleIcon = styled.div`
  font-size: 40px;
`

export const BurnDialogTitle = styled(Typography)`
  font-size: 18px;
  font-weight: 600;
`

export const BurnDialogDesc = styled(Typography)`
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  text-align: center;
  margin-bottom: 24px;
  max-width: 391px;
  white-space: pre-line;
`
